import React from "react";

export default ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
    <g>
      <rect width="7.38" height="2" x="11.63" y="8" className="euiIcon__fillSecondary"/>
      <rect width="3.19" height="2" x="7" y="8"/>
      <rect width="7.38" height="2" x="7" y="16" className="euiIcon__fillSecondary"/>
      <rect width="3.19" height="2" x="15.81" y="16"/>
      <rect width="9" height="2" x="7" y="12"/>
      <path
        d="M13,0 C5.82029825,-4.39629938e-16 8.79259876e-16,5.82029825 0,13 C-8.79259876e-16,20.1797017 5.82029825,26 13,26 C20.1797017,26 26,20.1797017 26,13 C26,9.55218563 24.6303611,6.24558476 22.1923882,3.80761184 C19.7544152,1.36963892 16.4478144,2.11117741e-16 13,0 Z M13,24 C6.92486775,24 2,19.0751322 2,13 C2,6.92486775 6.92486775,2 13,2 C19.0751322,2 24,6.92486775 24,13 C24,19.0751322 19.0751322,24 13,24 Z"/>
      <rect width="2" height="10.9" x="26.142" y="21.69" transform="rotate(-45 27.142 27.14)"/>
    </g>
  </svg>
);
